export const siteConfig = {
  name: "Marketier Agency",
  url: "https://marketieragency.com",
  description: "Charleston's premier digital marketing agency. We help local small businesses grow online with branding, web development, SEO, social media, and digital advertising.",
  baseLinks: {
    home: "/",
  },
}